"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.segmentInfo = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interfaces = require("./interfaces");

var _utils = require("./utils");

var _segmentInfo;

var segmentInfo = (_segmentInfo = {}, (0, _defineProperty2.default)(_segmentInfo, _interfaces.DateTimeSegment.Year, {
  min: 1900,
  getMax: function getMax() {
    return 9999;
  },
  placeholder: 'YYYY',
  width: 43
}), (0, _defineProperty2.default)(_segmentInfo, _interfaces.DateTimeSegment.Month, {
  min: 1,
  getMax: function getMax() {
    return 12;
  },
  placeholder: 'MM',
  width: 32
}), (0, _defineProperty2.default)(_segmentInfo, _interfaces.DateTimeSegment.Day, {
  min: 1,
  getMax: function getMax(_ref) {
    var month = _ref.month,
        year = _ref.year;
    return month !== undefined && year !== undefined ? (0, _utils.daysInMonth)(month, year) : 31;
  },
  placeholder: 'DD',
  width: 27
}), (0, _defineProperty2.default)(_segmentInfo, _interfaces.DateTimeSegment.Hours, {
  min: 0,
  getMax: function getMax() {
    return 23;
  },
  placeholder: 'hh',
  separator: "\xA0",
  // &nbsp;
  width: 22
}), (0, _defineProperty2.default)(_segmentInfo, _interfaces.DateTimeSegment.Minutes, {
  min: 0,
  getMax: function getMax() {
    return 59;
  },
  placeholder: 'mm',
  separator: ':',
  width: 32
}), (0, _defineProperty2.default)(_segmentInfo, _interfaces.DateTimeSegment.Seconds, {
  min: 0,
  getMax: function getMax() {
    return 59;
  },
  placeholder: 'ss',
  separator: ':',
  width: 22
}), (0, _defineProperty2.default)(_segmentInfo, _interfaces.DateTimeSegment.Milliseconds, {
  min: 0,
  getMax: function getMax() {
    return 999;
  },
  placeholder: 'sss',
  separator: '.',
  width: 32
}), _segmentInfo);
exports.segmentInfo = segmentInfo;